import { useInfiniteQuery } from "@tanstack/react-query";
import {
  fetchPotentialAreasToMembership,
  PotentialAreasResponse,
} from "src/Pages/Company/EmployeeManagement/CompanyEmployees/Edit/OrganizationStructure/api";

interface UseFetchPotentialAreasToMembershipParams {
  companyId: string;
  employeeId: string;
  query?: string;
  filters?: string;
  enabled?: boolean;
}

const useFetchPotentialAreasToMembership = ({
  companyId,
  employeeId,
  query,
  filters: rawFilters,
  enabled = true,
}: UseFetchPotentialAreasToMembershipParams) => {
  const normalizedQuery = query?.trim();
  const nameFilters = normalizedQuery
    ? `(${normalizedQuery
        .split(/\s+/)
        .map((word) => `name=like=*${word}*`)
        .join(";")})`
    : null;

  const resolvedFilters = rawFilters ?? nameFilters;

  return useInfiniteQuery<PotentialAreasResponse, Error>({
    queryKey: [
      "fetch-potential-areas-to-membership",
      companyId,
      employeeId,
      resolvedFilters,
    ],
    queryFn: async ({ pageParam, signal }) => {
      const data = await fetchPotentialAreasToMembership(
        companyId,
        employeeId,
        {
          signal,
          nextCursor: pageParam,
          query: resolvedFilters,
        }
      );
      return data;
    },
    enabled: enabled && !!companyId && !!employeeId,
    initialPageParam: null,
    getNextPageParam: (lastPage) => lastPage.nextCursor || null,
    placeholderData: (previousData) =>
      previousData ?? { pages: [], pageParams: [] },
  });
};

export default useFetchPotentialAreasToMembership;
